import GovmapImagePopup from './GovmapImagePopup';

export default GovmapImagePopup;
